import { ElementType, ReactNode, useMemo } from 'react';
import { styled, Typography, Tooltip } from '@mui/material';

const MoreText = styled(Typography)<{
  component: ElementType;
}>(({ theme }) => ({
  borderBottom: `1px dotted ${theme.palette.text.secondary}`,
}));

export default function MoreTexts({ texts, isOr, prefix }: { texts: string[]; isOr?: boolean; prefix?: ReactNode }) {
  const firstText = useMemo(() => {
    if (texts.length === 0) return null;

    if (prefix) {
      return (
        <>
          {prefix} {texts[0]}
        </>
      );
    }

    return <>{texts[0]}</>;
  }, [prefix, texts]);

  if (texts.length === 1) {
    return <Typography variant="body2">{firstText}</Typography>;
  }

  const moreTexts = texts.slice(1);

  return (
    <Typography variant="body2" noWrap>
      {firstText} {isOr ? 'or' : 'and'}{' '}
      <Tooltip title={moreTexts.map((t) => t).join(', ')} arrow placement="top">
        <MoreText variant="body2" component="span">
          {moreTexts.length} more
        </MoreText>
      </Tooltip>
    </Typography>
  );
}
